import React, { Component } from 'react';
import { ReactComponent as CalendarIcon } from '../../../assets/svg/calendar3.svg';
import _ from 'lodash';
class CustomDateInput extends Component {
	render() {
		const { ref, ...props } = this.props;
		return (
			<div className={`floating-label ${props.isInputError ? 'error-label' : ''}`}>
				{_.has(this.props, 'showDateIcon') && this.props.showDateIcon === true ? (
					<span
						className="date-icon-absolute"
						style={{ pointerEvents: 'none', cursor: 'pointer' }}
					>
						<CalendarIcon />
					</span>
				) : null}
				<input
					{...props}
					className={`${props.className} floating-input`}
					placeholder=" "
					ref={ref}
				/>
				<label className="labelInput">
					{props.isInputError ? props.errorMessage : props.customLabel}
					{_.has(props, 'requiredField') && props.requiredField ? (
						<span className="required-input-new">{props.isInputError ? '' : '*'}</span>
					) : null}
				</label>
			</div>
		);
	}
}

export default React.forwardRef((props, ref) => <CustomDateInput ref={ref} {...props} />);
